import client, { BASE_URL } from "./client";
import { clearGeoCache } from "./geoCache";
import { createPendingRequests } from "./pendingRequests";
export { BASE_URL };

const pendingReads = createPendingRequests();

const request = (methodName, endPoint, data, authorization = false) => {
   let headers = {};
   if (authorization) {
      headers = {
         Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
      };
   }
   const send = () => client({
      method: methodName,
      url: endPoint,
      headers,
      data,
   });
   if (methodName === "GET") {
      // Auth identity is part of the key so users never share an in-flight read.
      return pendingReads.run(JSON.stringify([endPoint, headers.Authorization]), send);
   }
   // Reads initiated after a write must not join a pre-write request.
   const invalidate = () => {
      pendingReads.clear();
      if (endPoint.startsWith("/geo/")) clearGeoCache();
   };
   invalidate();
   return send().finally(invalidate);
};

export const getService = (endPoint, authorization) =>
   request("GET", endPoint, null, authorization);

export const postService = (endPoint, data, authorization) =>
   request("POST", endPoint, data, authorization);

export const putService = (endPoint, data, authorization) =>
   request("PUT", endPoint, data, authorization);

export const patchService = (endPoint, data, authorization) =>
   request("PATCH", endPoint, data, authorization);

export const deleteService = (endPoint, authorization) =>
   request("DELETE", endPoint, null, authorization);
